import postSourceView from './postSourceComponent.html';
import './postSourceComponent.css';

export function postSourceComponent() {
	return {
		bindings: {
			post: '<',
		},
		controllerAs: 'vm',
		controller: postSourceComponentCtrl,
		template: postSourceView,
	};
}

export class postSourceComponentCtrl {}
